// Each system's barcode has its own infix after the checksum digit — mirrors the
// backend's finishItemId in each api/*OrdersApi.py (OP: 'P', SP: 'S0', IP: 'I00').
const SYSTEM_INFIXES = {
  OP: "P",
  SP: "S0",
  IP: "I00",
};

export function finishItemId(itemId, system = "OP") {
  if (itemId == null || itemId === "") {
    return itemId;
  }
  const digits = String(itemId)
    .split("")
    .reduce((sum, char) => sum + parseInt(char, 10), 0);
  const firstDigit = digits % 10;
  const infix = SYSTEM_INFIXES[system] || SYSTEM_INFIXES.OP;
  return `${firstDigit}${infix}${itemId}`;
}
